import { BsBoxSeam } from 'react-icons/bs';
import { FaClock, FaTruckLoading } from 'react-icons/fa';
import { IoMdContact } from 'react-icons/io';
import { PiLockersFill } from 'react-icons/pi';
import { translate } from '../utils/Common';

export const rawColumnsByMode = {
  packages: [
    { id: 'packageId', name: `ID ${translate("global.Package")}`, isVisible: true, order: 1 },
    { id: 'tracking', name: `${translate("global.numTracking")}`, isVisible: true, order: 6, icon: FaTruckLoading },
    { id: 'packageNum', name: translate("global.numPackage"), isVisible: true, order: 1 , icon: BsBoxSeam },
    { id: 'customer', name: translate("global.client"), isVisible: true, order: 3, icon: IoMdContact },
    { id: 'pkgStatus', name: translate("global.status"), isVisible: true, order: 5, icon: FaClock },
    { id: 'location', name: translate("global.ubication"), isVisible: true, order: 2, icon: PiLockersFill },
    { id: 'doorNum', name: translate("global.numDoor"), isVisible: false, order: 15 },
    { id: 'pkgWeight', name: translate("global.weight"), isVisible: false, order: 7 },
    { id: 'dateCreatePkg', name: translate("global.dateCreated"), isVisible: false, order: 8 },
    { id: 'dateExpiredPkg', name: translate("global.dateExpiration"), isVisible: false, order: 9 },
    { id: 'totalCost', name: translate("dashboard.packages.loadpackages.formProvider.costTotal"), isVisible: false, order: 10 },
    { id: 'sizePkg', name: translate("global.size"), isVisible: false, order: 11 },
    { id: 'clientId', name: "ID "+ translate("global.client"), isVisible: false, order: 12 },
    { id: 'email', name: translate("global.email"), isVisible: false, order: 13 },
    { id: 'pkgType', name: translate("global.typeOfPackage"), isVisible: false, order: 14 },
  ],
};
